export function formatDate(value, options = {}) {
  if (!value) return options.empty || "—"
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return String(value)
  const formatterOptions = options.dateOnly
    ? { day: "2-digit", month: "2-digit", year: "numeric" }
    : { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false }
  if (options.timeZone) formatterOptions.timeZone = options.timeZone
  return new Intl.DateTimeFormat("ru-RU", formatterOptions).format(date).replace(",", ",")
}

export function formatNumber(value, options = {}) {
  return new Intl.NumberFormat("ru-RU", options).format(Number(value) || 0)
}

export const IMPORT_KIND_LABELS = { partners: "Партнёры", report: "Статистика", traffic: "Трафик" }
export const STATUS_LABELS = { pending: "Ожидает", running: "Выполняется", succeeded: "Готово", failed: "Ошибка" }
export const PRIORITY_LABELS = { lowest: "Самый низкий", low: "Низкий", medium: "Средний", high: "Высокий", highest: "Критический" }
